/* global window */
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { deleteCompany2, companyDeleted } from 'actions/company';

import { Link } from 'react-router';
import NotFound from 'components/NotFound';
import NavBarConfig from 'components/NavBarConfig';
import CompanyDelete from 'components/company/CompanyDelete';
import { FORM_ERROR } from 'final-form';

const messages = defineMessages({
  BACK: {
    id: 'CompanyDeletePage.BACK',
    defaultMessage: 'Zurück',
  },
  DELETE_COMPANY: {
    id: 'CompanyDeletePage.DELETE_COMPANY',
    defaultMessage: 'Unternehmen löschen',
  },
  QUESTION_DELETE_COMPANY: {
    id: 'CompanyDeletePage.QUESTION_DELETE_COMPANY',
    defaultMessage: 'Sind sie sich sicher, dass sie dieses Unternehmen wirklich löschen wollen?',
  },
  CAN_NOT_REVOKED: {
    id: 'CompanyDeletePage.CAN_NOT_REVOKED',
    defaultMessage: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  },
  ATTENTION: {
    id: 'CompanyDeletePage.ATTENTION',
    defaultMessage: 'Achtung',
  },
});

function CompanyDeletePage({ user, company, onSubmit, routes, intl: { formatMessage } }) {
  if (!company) { return null; }
  if (!user.is_admin) {
    return <NotFound />;
  }
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig deletePage currentRouteName={routes[routes.length - 1].name} />
      
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '1000px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <Link to={`/company/${company.id}/settings/`} style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: 'var(--btn-default-bg)', border: '1px solid var(--btn-default-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-color)', textDecoration: 'none', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
              <i className="fa fa-arrow-left" />
            </Link>
            <div>
              <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)' }}>{formatMessage(messages.DELETE_COMPANY)}</h2>
              <p style={{ margin: '4px 0 0 0', color: 'var(--text-muted)' }}>{company.name}</p>
            </div>
          </div>

          {/* Main Card without Aura */}
          <div style={{ backgroundColor: 'var(--panel-bg)', borderRadius: '24px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
            <div style={{ padding: '32px' }}>
              <div style={{ maxWidth: '600px' }}>
                <div style={{ padding: '16px', backgroundColor: '#fef2f2', borderLeft: '4px solid #dc2626', borderRadius: '8px', marginBottom: '24px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                  <i className="fa fa-exclamation-triangle" style={{ color: '#dc2626', fontSize: '20px', marginTop: '2px' }} />
                  <div>
                    <h4 style={{ margin: '0 0 4px 0', color: '#991b1b', fontWeight: 'bold' }}>{formatMessage(messages.ATTENTION)}</h4>
                    <p style={{ margin: 0, color: '#b91c1c', fontSize: '14px' }}>
                      {formatMessage(messages.QUESTION_DELETE_COMPANY)}<br />
                      {formatMessage(messages.CAN_NOT_REVOKED)}
                    </p>
                  </div>
                </div>

                <CompanyDelete onSubmit={onSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null,
  (dispatch, { params }) => ({
    onSubmit: async () => {
      const data = await deleteCompany2(params.companyId);
      if (data.error === undefined || data.error === null) {
        dispatch(companyDeleted({ companyId: params.companyId }));
        dispatch(push('/company/'));
        window.location.reload();
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    }
  })
)(injectIntl(CompanyDeletePage));
